const datepickerDateFormat = {
    day_month_year: 'd/m/Y',
    month_day_year: 'm/d/Y',
    year_month_day: 'Y/m/d',
    '24_hour_minute': 'H:i',
    '12_hour_minute': 'G:i K'
};

export default datepickerDateFormat;
